/**
 * A shop's help request reaches the platform admin by itself (1.45, the owner,
 * 2026-10-15: a sound and an unread „1", on the computer — Telegram brings it
 * to the phone, lib/platform-telegram.ts).
 *
 * The admin's app asks `support_requests()` every 30 s wherever it is — the
 * shop shell or the console. A request that was not in the previous answer has
 * ARRIVED: it chimes and says so. The rules are the online orders' own
 * (lib/order-alerts.ts): the first answer is the baseline, a device's tabs say
 * each request once, and the count pulses until the console is in view. A
 * request is stamped with the time its owner SENT it (the server's clock).
 *
 * Pure: components/support-alerts.tsx asks, chimes and draws.
 */
import type { Key } from './i18n'
import { payCode } from './subscription'

/** What the alert needs of a `support_requests()` row. */
export type AlertRequest = { id: string; org_name: string; billing_no: number; sent_at: string }

/** This device's „seen up to" mark — the console is the admin's, not a shop's. */
export const SUPPORT_SEEN_KEY = 'martepos:support-seen'
/** The newest request this device already announced, shared by its tabs. */
export const SUPPORT_ANNOUNCED_KEY = 'martepos:support-announced'

/** The order-alert rules read `created_at`: a request arrives when it was sent. */
export const stamped = <T extends { sent_at: string }>(r: T): T & { created_at: string } => ({ ...r, created_at: r.sent_at })

/** One request: the shop and its MP code; several: how many. */
export function supportAlertMessage(arrived: AlertRequest[]): { key: Key; vars: Record<string, string | number> } {
  if (arrived.length === 1) return { key: 'sup.alert.one', vars: { shop: arrived[0].org_name, no: payCode(arrived[0].billing_no) } }
  return { key: 'sup.alert.many', vars: { n: arrived.length } }
}
